// extracted by mini-css-extract-plugin
export default {"cls1":"apK6ACVQn5e_t3oDvBkf","cls2":"oOwIvyQzhr3YZ6BnIJ62 apK6ACVQn5e_t3oDvBkf"};